import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RpmStatusTriangle } from '../../../../../../../../assets/Logos/Icons'

import heartBeatImage from '../../../../../../../../assets/RpmAssets/PNGIcons/heart-beat.png'
import Spinner from "react-bootstrap/Spinner";
import { Glucoseicon } from '../../../../../../../../assets/Logos/Icons'


function Glucose() {
    let reduxData = useSelector(state => state) ; 
    console.log("Redux Data in RpmProfile: ",reduxData);
    let patientDetails = reduxData.rpmreducer.vitalhistory && 
                            reduxData.rpmreducer.vitalhistory.data.blood_suger;
    
    
    console.log(patientDetails)
    useEffect(() => {
     
      },[])
    return (

        <div className='blood-pressure-vital-container'>

            <div className="blood-pressure-vital-container_details">
            {patientDetails!=undefined && patientDetails.length>0 ? (
                <ul className='patient-vitals-list'>
                    {
                        patientDetails.map((element,key) => {
                            return (
                                <li className={key===0&&'patient-vitals-list_active'} key={key}>


                                    <div className="left">
                                       <Glucoseicon/>

                                        <span className='item'> Glucose </span>

                                        {/* <div className="icon">
                                            <RpmStatusTriangle variant="abnormal" size="13" />
                                        </div> */}

                                        <span className='value'>{element.glucose}</span>
                                        <span className='unit'>mmol/L</span>
                                        
                                    </div>

                                    {/* <div className="left">
                                        {element.blood_oxygenvideo!=''&&
                                                <a href={element.blood_oxygenvideo} target="_blank">  <img src={videoplay} alt="" /></a>
                                            }
                                    </div>  */}

                                    <div className="left">

                                        <span className='unit'>as on {element.date}</span>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            ):patientDetails == undefined ? (
                <div className='loader'>
                    {/* ****IMPORTANT Loader is not working */}
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>):"No Data Available"}
            </div>

            {/* <div className="blood-pressure-vital-container_graph">
                
                <span className="title">Average Blood Pressure - Last 10 readings</span>

                <div className="dummy-graph"> (Graph)</div>

            </div> */}

        </div>
    )
}

export default Glucose